import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { LostStrandType } from "@/pages/caster/models/caster.models";
import { useGridStyles } from "@/pages/laboratory/styles/gridStyles";
import { Button, Grid2 as Grid, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useCatalogLostStrandTypesContext } from "../CatalogLostStrandTypesContext";
import { UpsertLostStrandType } from "./UpsertLostStrandType";
import { useTableData } from "./hooks";
type Props = {
	getLostStrandTypesFromAPI: Function;
	isLoading: boolean;
};

export const TableLostStrandTypes = ({
	getLostStrandTypesFromAPI,
	isLoading,
}: Props) => {
	const {
		state: { lostStrandTypes },
	} = useCatalogLostStrandTypesContext();
	const classes = useGridStyles();
	const [modalMode, setModalMode] = useState<
		"create" | "edit" | "delete" | null
	>(null);
	const [lostStrandType, setLostStrandType] = useState<LostStrandType | null>(
		null,
	);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns } = useTableData({
		onDeleteButtonClick: (lostStrandTypeId: number) => {
			setModalMode("delete");
			const lostStrandType = lostStrandTypes?.find(
				(row) => row.LostStrandTypeId === lostStrandTypeId,
			);
			if (lostStrandType) {
				setLostStrandType(lostStrandType);
			}
		},
		onEditButtonClick: (lostStrandTypeId: number) => {
			setModalMode("edit");
			const lostStrandType = lostStrandTypes?.find(
				(row) => row.LostStrandTypeId === lostStrandTypeId,
			);
			if (lostStrandType) {
				setLostStrandType(lostStrandType);
			}
		},
	});

	return (
		<>
			<Grid size={{ xs: 12 }} container justifyContent="center" spacing={1}>
				<Grid size={{ xs: 12, md: 12 }}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Lost Strand Types
					</Typography>
				</Grid>

				<Grid
					size={{ xs: 12 }}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid size={{ xs: 12 }} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search lost strand types"
						/>
					</Grid>
					<Grid
						size={{ xs: 12, md: 12 }}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.LostStrandTypeId}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setLostStrandType(params.data);
									setModalMode("edit");
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid size={{ xs: 12, md: "auto" }} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => {
								setLostStrandType(null);
								setModalMode("create");
							}}
						>
							NEW LOST STRAND TYPE
						</Button>
					</Grid>
				</Grid>
			</Grid>
			<UpsertLostStrandType
				show={modalMode}
				onHide={() => {
					setModalMode(null);
					setLostStrandType(null);
					getLostStrandTypesFromAPI();
				}}
				lostStrandType={lostStrandType}
			/>
		</>
	);
};
